"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { WorkspaceElementType } from '@integration-app/sdk';
import { useElement } from '../useElement.mjs';

function useFlow(selector) {
  const {
    item: flow,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.Flow,
    selector,
    (integrationApp) => selector ? integrationApp.flow(selector) : void 0
  );
  async function apply(integrationKeys) {
    const result = await accessor?.apply(integrationKeys);
    await refresh();
    return result;
  }
  async function reset() {
    await accessor?.reset();
    return await refresh();
  }
  return { flow, apply, reset, refresh, accessor, ...rest };
}

export { useFlow };
